import { combineReducers } from "redux"
import type { StateObject } from "./types"
import { createDefaultFiltersState, filtersReducer } from "../filters/reducer"
import { authReducer, createDefaultAuthState } from "../auth/reducer"
import { createDefaultSchematizedState, schematizedReducer } from "../screens/salesInput/schematized/reducer"
import { createDefaultDataState, dataReducer } from "../data/reducer"
import { createDefaultOperationsState, operationsReducer } from "../operations/reducer"
import { createDefaultLocationsPickerState, locationsPickerReducer } from "../common/locationsPicker/reducer"
import { createDefaultRouterState, routerReducer } from "../router/reducer"
import { createDefaultItemsCategoriesState, itemsCategoriesReducer } from "../screens/categories/reducer"
import { createDefaultReportsState, reportsReducer } from "../screens/reports/reducer"
import { createDefaultSettingsState, settingsReducer } from "../screens/settings/reducer"
import { createDefaultInventoryState, inventoryReducer } from "../screens/inventory/reducer"
import { createDefaultTerminalState, terminalReducer } from "../screens/locations/reducer"
import { assignmentsReducer, createDefaultAssignmentsState } from "../screens/assignments/reducer"
import { createDefaultPricingsState, pricingsReducer } from "../screens/pricingsAndPromotions/pricing/reducer"
import { consoleReducer, createDefaultState } from "../screens/console/reducer"

export const initialState: StateObject = {
    data: createDefaultDataState(),
    operations: createDefaultOperationsState(),
    filters: createDefaultFiltersState(),
    auth: createDefaultAuthState(),
    schematized: createDefaultSchematizedState(),
    locationsPicker: createDefaultLocationsPickerState(),
    router: createDefaultRouterState(),
    assignments: createDefaultAssignmentsState(),
    itemsCategories: createDefaultItemsCategoriesState(),
    reports: createDefaultReportsState(),
    pricing: createDefaultPricingsState(),
    settings: createDefaultSettingsState(),
    inventory: createDefaultInventoryState(),
    terminal: createDefaultTerminalState(),
    console: createDefaultState(),
}

export const mainReducer = combineReducers({
    data: dataReducer,
    operations: operationsReducer,
    filters: filtersReducer,
    auth: authReducer,
    schematized: schematizedReducer,
    locationsPicker: locationsPickerReducer,
    router: routerReducer,
    assignments: assignmentsReducer,
    itemsCategories: itemsCategoriesReducer,
    reports: reportsReducer,
    pricing: pricingsReducer,
    settings: settingsReducer,
    inventory: inventoryReducer,
    terminal: terminalReducer,
    console: consoleReducer,
})
